import React, { FunctionComponent, useEffect } from 'react';
import css from './MentionsOfficialAccountPostRoute.module.less';
import MentionsOfficialAccountPostList from '@components/MentionsOfficialAccountPostList';
import MentionsOfficialAccountSelector from '@components/MentionsOfficialAccountSelector';
import useMentionsOfficialAccountFilters from '@hooks/useMentionsOfficialAccountFilters';

interface MentionsOfficialAccountPostRouteProps {}

const MentionsOfficialAccountPostRoute: FunctionComponent<
  MentionsOfficialAccountPostRouteProps
> = () => {
  const { getList } = useMentionsOfficialAccountFilters();

  useEffect(() => {
    getList();
  }, []);

  return (
    <div className={css.root}>
      <div>
        <MentionsOfficialAccountSelector />
      </div>
      <MentionsOfficialAccountPostList />
    </div>
  );
};

export default MentionsOfficialAccountPostRoute;
